import $ from "jquery"
import TemplateView from '../TemplateView'
import messageResource from '../messageResource'
import makeRpcCall from '../util/jquery_rpc'
import {CREATE_TASKS_CONSTANTS} from './constants'
import CreateTasksCustomerProjectSelector from './CreateTasksCustomerProjectSelector'
import TaskTableTemplate from "../taskManagement/createLightbox/TaskTableTemplate";
import ImportTasksSelector from "../taskManagement/createLightbox/ImportTasksSelector";
import ImportTasksSelectorButton from "../taskManagement/createLightbox/ImportTasksSelectorButton";
import ExitConfirmationHandlersManager from '../ExitConfirmationHandlersManager'
import ClassicBridge from "../next/ClassicBridge"
import { mergeClassicAndNextTask } from "../next/utils"

const INITIAL_NUMBER_OF_ROWS = 3;
const INITIAL_NUMBER_OF_ROWS_WHEN_OPENED_FROM_OPEN_TASKS = 5;

export class CreateTaskLightboxContent extends TemplateView {
    constructor({
                    customers,
                    projects,
                    billingTypes,
                    defaultBillingTypeId,
                    canEditHierarchy,
                    canAddTasksToUser,
                    weekStartDay,
                    scheduleCalculator,
                    estEnabled,
                    tstEnabled,
                    projectsWithTasksExist,
                    isOpenedFromOpenTasks,
                    selectedCustomerId,
                    selectedProjectId,
                    selectedUserId,
                    user,
                    dayOnWeek,
                    userManagementAssignmentsData
                },
                {
                    onChangedDataCb = () => {},
                    validationCb = () => {},
                    getScrollPositionCallback = () => 0,
                    refreshScrollCb = () => {}
                }) {
        super(null)

        this.params = {
            customers,
            projects,
            billingTypes,
            defaultBillingTypeId,
            canEditHierarchy,
            canAddTasksToUser,
            weekStartDay,
            scheduleCalculator,
            estEnabled,
            tstEnabled,
            projectsWithTasksExist,
            isOpenedFromOpenTasks,
            selectedCustomerId,
            selectedProjectId,
            selectedUserId,
            user,
            dayOnWeek,
            userManagementAssignmentsData
        }

        this.callbacks = {
            onChangedDataCb,
            validationCb,
            getScrollPositionCallback,
            refreshScrollCb,
        }
    }


    templateHtml() {
        return '<div class="innerContent">' +
               '    <div class="customerProjectSelectorPlaceholder"></div>' +
               '    <div class="importTasksHeader">' +
               '        <div class="title"><%-importTasksHeader%></div>' +
               '        <div class="importTasksSelectorButtonContainer"></div>' +
               '    </div>' +
               '    <div class="tablePlaceholder"></div>' +
               '</div>'
    }

    afterRender() {
        this.customerProjectSelector = new CreateTasksCustomerProjectSelector({
            customers: this.params.customers,
            projects: this.params.projects,
            canEditHierarchy: this.params.canEditHierarchy,
            selectedCustomerId: this.params.selectedCustomerId,
            selectedProjectId: this.params.selectedProjectId,
            changesCallback: this.callbacks.onChangedDataCb,
            validationCallback: this.callbacks.validationCb,
            scrollableContainer: this.$el,
            userManagementAssignmentsData: this.params.userManagementAssignmentsData
        }).init(this.getCustomerProjectSelectorSection());

        this.initImportTasksSelector();

        this.initCreateTasksComponent();
    }

    templateModel() {
        return {
            id: 'createTasksPopup'
        }
    }

    messageKeys() {
        return {
            importTasksHeader: 'add_new_tasks.new_tasks'
        }
    }

    getCustomerProjectSelectorSection() {
        return this.find(".customerProjectSelectorPlaceholder")
    }

    getImportTasksContainer() {
        // TODO set correct value
        return this.createTasksComponent.getEl()
    }

    getCustomerProjectSelector() {
        return this.customerProjectSelector
    }

    validateCustomerProjectSelector() {
        return this.customerProjectSelector.validate()
    }

    validateTasksTableComponent() {
        return this.createTasksComponent.validate();
    }

    isTaskTableComponentEmpty() {
        return this.createTasksComponent.isEmpty();
    }

    hasErrors() {
        return (
            this.customerProjectSelector && this.customerProjectSelector.hasErrors() ||
            (this.createTasksComponent && this.createTasksComponent.hasErrors())
        );
    }

    getData() {
        const cpValues = this.customerProjectSelector.getValues();
        const tasks = this.createTasksComponent.getTasks();

        return [
            cpValues.customerId,
            cpValues.newCustomerName,
            cpValues.projectId,
            cpValues.newProjectName,
            cpValues.selectedProjectNames,
            tasks
        ];

    }

    initImportTasksSelector() {
        this.importTasksSelector = new ImportTasksSelector($("body"), {
            scrollableContainer: this.$el,
            canSelectAllInCustomer: true,
            canSelectAllInProject: true,
            selectionCallback: ({taskIds, customerId, projectId, importDescriptions, importOnlyActiveProjects}) => {
                this.createTasksComponent.importTasksRequest(taskIds, importDescriptions, customerId, projectId, importOnlyActiveProjects);
                this.importTasksSelector.hidePanel()
            }
        }).init();
        this.importTasksSelector.setState({
            user: this.params.user
        });

        const importTasksSelectorButton = new ImportTasksSelectorButton(() => {
            this.importTasksSelector.showPanel({of: importTasksSelectorButton.$el})
        }).init(this.find(".importTasksSelectorButtonContainer"));
    }

    initCreateTasksComponent() {
        var defaultRowsNumber = this.params.isOpenedFromOpenTasks ?
                                INITIAL_NUMBER_OF_ROWS_WHEN_OPENED_FROM_OPEN_TASKS :
                                INITIAL_NUMBER_OF_ROWS;


        this.createTasksComponent = new TaskTableTemplate(
            this.find(".tablePlaceholder"),
            {
                billingTypes: this.params.billingTypes,
                defaultBillingTypeId: this.params.defaultBillingTypeId,
                canAddTasksToUser: this.params.canAddTasksToUser,
                weekStartDay: this.params.weekStartDay,
                scheduleCalculator: this.params.scheduleCalculator,
                estEnabled: this.params.estEnabled,
                tstEnabled: this.params.tstEnabled,
                defaultRowsNumber: defaultRowsNumber,
                isOpenedFromOpenTasks: this.params.isOpenedFromOpenTasks,
                changesCallback: this.callbacks.onChangedDataCb,
                validateCallback: this.callbacks.validationCb,
                scrollableContainer: this.$el,
                getScrollPositionCallback: this.callbacks.getScrollPositionCallback,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }
        ).init();
    }

    getTaskComponent() {
        return this.createTasksComponent;
    }

    getCustomerName(customerId) {
        for (let c = 0; c < this.params.customers.length; c++) {
            if (this.params.customers[c].id === customerId)
                return this.params.customers[c].name;
        }
        return "";
    }

    getProjectName(projectId) {
        for (let j = 0; j < this.params.projects.length; j++) {
            if (this.params.projects[j].id === projectId)
                return this.params.projects[j].name;
        }
        return "";
    }

    handleCustomerProjectError(customerProjectError, customerId, projectId, selectedProjectNames, customers, projects) {
        let msgKey;

        switch (customerProjectError) {
            case CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_EXIST_ERROR:
                alert(messageResource.getMessage('add_new_tasks.customer_deleted'));
                this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects);
                this.customerProjectSelector.addCustomerNotSelectedError();
                break;

            case CREATE_TASKS_CONSTANTS.CUSTOMER_EXISTS_ERROR:
                this.customerProjectSelector.addCustomerExistsError();
                break;

            case CREATE_TASKS_CONSTANTS.CUSTOMER_IS_ARCHIVED_ERROR: {
                const customerName = this.getCustomerName(customerId);
                msgKey = this.params.canEditHierarchy ? 'add_new_tasks.customer_archived' : 'add_new_tasks.customer_archived.cant_manage_projects';
                alert(messageResource.getMessage(msgKey, [customerName]));
                this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects);
                this.customerProjectSelector.addCustomerNotSelectedError();
                break;
            }
            case CREATE_TASKS_CONSTANTS.NO_ACTIVE_CUSTOMERS_ERROR:
                this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(null, null);
                this.customerProjectSelector.addNoActiveCustomersError();
                break;

            case CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_EXIST_ERROR:
                alert(messageResource.getMessage('add_new_tasks.project_unavailable'));
                this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                this.customerProjectSelector.addProjectNotSelectedError();
                break;

            case CREATE_TASKS_CONSTANTS.PROJECT_EXISTS_ERROR:
                this.customerProjectSelector.addProjectExistsError();
                break;

            case CREATE_TASKS_CONSTANTS.PROJECT_IS_ARCHIVED_ERROR:
                const projectName = this.getProjectName(projectId);
                msgKey = this.params.canEditHierarchy ? 'add_new_tasks.project_archived' : 'add_new_tasks.project_archived.cant_manage_projects';
                alert(messageResource.getMessage(msgKey, [projectName]));
                this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                this.customerProjectSelector.addProjectNotSelectedError();
                break;

            case CREATE_TASKS_CONSTANTS.NO_ACTIVE_PROJECTS_ERROR:
                if (selectedProjectNames) {
                    this.customerProjectSelector.removeProjectsFromList(selectedProjectNames, customerId);
                    if (selectedProjectNames.length > 1)
                        alert(messageResource.getMessage('add_new_tasks.projects_unavailable'));
                    else
                        alert(messageResource.getMessage('add_new_tasks.project_unavailable'));
                }
                else if (projectId === CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX) {
                    alert(messageResource.getMessage('add_new_tasks.projects_unavailable'))
                    this.customerProjectSelector.removeAllProjectsOfSelectedCustomer();
                    this.customerProjectSelector.addNoActiveProjectsError();
                }
                break;

            case CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_ASSIGNED_ERROR: {
                this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects)
                this.customerProjectSelector.addCustomerNotSelectedError()
                alert(messageResource.getMessage('add_new_tasks.customer_not_assigned.error'))
                break
            }

            case CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_ASSIGNED_ERROR: {
                alert(messageResource.getMessage('add_new_tasks.project_not_assigned.error'));
                this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                this.customerProjectSelector.addProjectNotSelectedError();
                break;
            }
        }
    }

    // TODO move to action provider
    sendCreateTasksRequest = (serviceName) => {
        const [customerId, newCustomerName, projectId, newProjectName, selectedProjectNames, tasks] = this.getData()

        return new Promise((resolve, reject) => {
            // TODO temporary commented
            const notEmptyTaskRowsNumbers = this.createTasksComponent.getCreateTasksTable().getNotEmptyRowsNumbers();

            const errorHandler = (jqXHR, textStatus, errorThrown) => {
                if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException') {
                    alert(messageResource.getMessage('add_new_tasks.no_right_create_tasks'));
                    document.location.reload();
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageCustomersAndProjectException') {
                    alert(messageResource.getMessage('add_new_tasks.no_right_create_project_customer'));
                    ExitConfirmationHandlersManager.restoreExitConfirmation()
                    document.location.reload();
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageSelectedProjectException') {
                    alert(messageResource.getMessage('add_new_tasks.project_unavailable'));
                    this.customerProjectSelector.removeProject(projectId);
                    this.customerProjectSelector.addProjectNotSelectedError();
                    return true;
                }

                reject()
                return false;
            };

            const successHandler = (result) => {
                if (result.customerProjectError) {
                    this.handleCustomerProjectError(
                        result.customerProjectError,
                        customerId,
                        projectId,
                        selectedProjectNames,
                        result.customers ? result.customers.list : null,
                        result.projects ? result.projects.list : null);
                }
                else if (result.taskError) {
                    const rowNumber = notEmptyTaskRowsNumbers[result.taskErrorRowNumber];
                    this.createTasksComponent.handleTaskError(result.taskError, rowNumber);
                } else if (result.billingTypeError) {
                    this.createTasksComponent.handleBillingTypeError(result.billingTypeError, result.billingTypes ? result.billingTypes.list : null);
                }

                let classicIds

                if (result.createdTaskIdsList)
                    classicIds = result.createdTaskIdsList.list
                else
                    classicIds = result.createdTasks.list.map(({ task }) => task.id)

                ClassicBridge.getTasksAfterModification(classicIds)
                    .then((nextTasks) => {
                        if (nextTasks)
                            result.createdTasks.list = result.createdTasks.list.map((createdTask) => {
                                const { task } = createdTask
                                const nextTask = nextTasks.find(({ classicId }) => classicId === task.id)
                                if (nextTask)
                                    return { ...createdTask, task: mergeClassicAndNextTask(task, nextTask) }
                                return createdTask
                            })

                        //todo: task list is empty case : alert( messageResource.getMessage( "add_new_tasks.js.unexpected_error" ) );
                        resolve(result)
                    })
                    .catch(() => resolve(result))
            };
            const data = [customerId, newCustomerName, projectId, newProjectName, selectedProjectNames, tasks];

            if (!this.params.isOpenedFromOpenTasks && this.params.selectedUserId && this.params.dayOnWeek) {
                data.push(this.params.selectedUserId);
                data.push(this.params.dayOnWeek);
            }

            makeRpcCall(serviceName + ".createNewTasks", data, successHandler, errorHandler);
        })

    }

}

export default CreateTaskLightboxContent



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTaskLightboxContent.js